<template>
  <div style="padding: 15px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="名称" prop="name">
        <el-input v-model.trim="form.name"   @change="(value)=>{form.name = value.replace(/\s/g,'')}" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" />
      </el-form-item>
      <el-form-item>
        <el-button @click="funcCancel">取 消</el-button>
        <el-button type="primary" @click="funcSubmit">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { stationCode, updateStation } from "@/api/station";
export default {
  name: "StationEdit",
  data() {
    return {
      form: {
      },
      partyGroup:[],
      rules: {
        remark: [
          { required: true, message: "请输入备注", trigger: "blur" },
          { min: 1, max: 255, message: '长度在 1 到 255个字符', trigger: 'blur' }
          ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      }
    };
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.form = {};
      stationCode(code).then(response => {
        this.form = response.data;
        this.form.code = code;
      });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          updateStation(this.form).then(response => {
            rLoading.close();
            this.$message({ message: response.msg, type: "success" });
            this.$emit("hideModel");
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("hideModel");
    }
  }
};
</script>
